module.exports = __webpack_public_path__ + "static/sca-grey-7fdadbe93518d15ef3dab56331679931.png";